import {Rule} from 'antd/es/form';

import {
    ADDITIONAL_FIELDS_TAB_FIELD_NAMES,
    FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS,
    FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_NAMES,
    FACTORS_REQUIRED_ERROR_MESSAGE,
} from '../model/constants';
import {IFactorResponseItem} from '../model/types';

/**
 * Определяет название вкладки по имени поля формы
 * @param fieldName - Имя поля формы (может быть строкой, числом или массивом)
 * @returns Название вкладки
 */
export const getTabNameByFieldName = (fieldName: string | number | (string | number)[]): string => {
    const fieldNameStr = Array.isArray(fieldName) 
        ? String(fieldName[0] ?? '') 
        : String(fieldName);
    
    if (fieldNameStr === FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS.FACTORS) {
        return FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_NAMES.FACTORS;
    }
    
    if ((ADDITIONAL_FIELDS_TAB_FIELD_NAMES as readonly string[]).includes(fieldNameStr)) {
        return FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_NAMES.ADDITIONAL;
    }
    
    return FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_NAMES.MAIN;
};

/**
 * Валидатор для проверки наличия хотя бы одного заполненного фактора
 */
export const validateFactorsRequired = (_: Rule, value: IFactorResponseItem[] | null | undefined) => {
    const hasFilledFactor = value && value.length > 0 && value.some((factor) => 
        factor?.factorNumber && factor?.factorName && factor?.factorTypeCodeId
    );
    
    if (!hasFilledFactor) {
        return Promise.reject(new Error(FACTORS_REQUIRED_ERROR_MESSAGE));
    }
    
    return Promise.resolve();
};

export const maxSizeRule = (maxSize: number) => (
    {max: maxSize, message: `Максимальная длина ${maxSize} символов`}
)
